/**
 * 收件箱提醒
 * @type {{}}
 */
const initState = {
  mailbox: {
    fromName: '',
    sendSn: '',
  },
  audit: {
    time: '',
    result: '',
  }

};

const mutations = {
  updateSocketMessage(state, {
    fromName, sendSn, time, result
  }) {
    if (fromName !== undefined) {
      state.mailbox.fromName = fromName;
    }
    if (sendSn !== undefined) {
      state.mailbox.sendSn = sendSn;
    }
    if (time !== undefined) {
      state.audit.time = time;
    }
    if (result !== undefined) {
      state.audit.result = result;
    }
  }
};

export default {
  namespaced: true,
  mutations,
  state: initState
};
